import { useTranslation } from 'react-i18next';
import { FormikProps } from 'formik';

import { buttonIds } from '@selfserve/react-utils';
import {
  StyledFormGroup,
  StyledInput,
  StyledButton,
} from '@selfserve/react-ui';

import { FormValues } from '../feature/forgot-password';

export interface Props {
  formik: FormikProps<FormValues>;
  isLoading: boolean;
}

export const ForgotPasswordForm = ({
  formik: { handleSubmit, handleChange, handleBlur, values, errors, touched },
  isLoading,
}: Props) => {
  const { t } = useTranslation();
  return (
    <form onSubmit={handleSubmit}>
      <StyledFormGroup unbold>
        <StyledInput
          id="txtEmail"
          name="email"
          inputLabel={t('common.email')}
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.email}
          error={touched.email ? !!errors.email : false}
          inputProps={{ 'aria-label': t('aria.email') }}
          autoFocus
          fullWidth
        />
        {touched.email && errors.email && (
          <p className="p-error">{errors.email}</p>
        )}
      </StyledFormGroup>
      <StyledButton
        id={buttonIds.resetPasswordSendInstructions}
        type="submit"
        variant={isLoading ? 'select' : 'pill'}
        loading={isLoading}
        disabled={isLoading}
        fullWidth
      >
        {t('common.send-instructions')}
      </StyledButton>
    </form>
  );
};
